module.exports = __webpack_public_path__ + "static/media/new-tank-medallion.923f37b6.jpg";